import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const MoreInfoIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4 5H20.032V6.968H4V5ZM4 14.984V12.968H20.032V14.984H4ZM20.032 8.984V11H4V8.984H20.032ZM14.032 17V18.968H4V17H14.032Z'
            fill='currentColor'
        />
    ),
})

MoreInfoIcon.displayName = 'MoreInfoIcon'
